// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2pF9Y","legacyBtn":"MutateMid_legacyBtn__38AM0"};